module.exports = __webpack_public_path__ + "img/Early_Morning_Icon.07ee813a.svg";